import { combineReducers } from "redux";

import country from "./Country";
import language from "./Language";
import store from "./Store";

export default combineReducers({ language, store, country });
